module.exports = __webpack_public_path__ + "static/media/food.b23d0ff6.jpg";